(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtc-final-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dtc-final-reviews')) customElements.define('dtc-final-reviews', class extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort = new AbortController(); const { signal } = this.abort;
  const expand = () => { this.classList.add('is-expanded'); this.querySelector('[data-expand-reviews]')?.setAttribute('aria-expanded', 'true'); };
  this.querySelector('[data-expand-reviews]')?.addEventListener('click', expand, { signal });
  document.addEventListener('shopify:block:select', e => { if (this.contains(e.target)) expand(); }, { signal });
 }
 disconnectedCallback() { this.abort?.abort(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-header"]) return;
  try {
    
document.addEventListener('keyup', (event) => { if (event.key !== 'Escape') return; document.querySelectorAll('.dtc-masthead__menu[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); }); });
if (!customElements.get('dtc-countdown')) customElements.define('dtc-countdown', class extends HTMLElement {
  connectedCallback() {
    clearInterval(this.timer);
    this.deadline = Date.now() + Number(this.dataset.seconds) * 1000;
    const tick = () => {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
      this.querySelector('[data-minutes]').textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
      this.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2, '0');
      if (!remaining) clearInterval(this.timer);
    };
    tick();
    this.timer = setInterval(tick, 1000);
  }
  disconnectedCallback() { clearInterval(this.timer); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-main-product"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('dtc-product')) {
    class DtcOfferController extends EventTarget {
      constructor(offers, preferred, count) {
        super();
        this.offers = offers;
        this.selected = offers.find((offer) => preferred && offer.variantId === preferred) || (/^[1-3]$/.test(count || '') ? offers[Number(count) - 1] : null) || offers.find((offer) => offer.checked) || offers[0];
        this.busy = false;
      }

      select(key) {
        const offer = this.offers.find((item) => item.key === key);
        if (!offer || this.busy) return;
        this.selected = offer;
        this.dispatchEvent(new Event('change'));
      }

      setBusy(value) {
        this.busy = value;
        this.dispatchEvent(new Event('change'));
      }
    }

    customElements.define('dtc-product', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        const offers = Array.from(this.querySelectorAll('[data-offer-area="primary"] [data-offer-input]'), (input) => ({
          items: JSON.parse(input.parentElement?.querySelector('[data-offer-items]')?.textContent || '[]'),
          key: input.value,
          variantId: input.dataset.variantId,
          available: input.dataset.available === 'true',
          purchasable: input.dataset.purchasable === 'true',
          availability: input.dataset.availability || '',
          discount: input.dataset.discount || '',
          mediaId: input.dataset.mediaId,
          price: input.dataset.price,
          compare: input.dataset.compare || '',
          savings: input.dataset.savings || '',
          tier: input.dataset.tier,
          checked: input.checked
        }));
        this.controller = new DtcOfferController(offers, new URL(location.href).searchParams.get('variant'), new URL(location.href).searchParams.get('count'));
        this.controller.addEventListener('change', () => this.render(), { signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-gallery-step]');
          if (!button) return;
          const gallery = this.querySelector('media-gallery');
          const slides = Array.from(gallery.querySelectorAll('[data-media-id]')).filter((slide) => slide.matches('li'));
          const active = slides.findIndex((slide) => slide.classList.contains('is-active'));
          const next = (active + Number(button.dataset.galleryStep) + slides.length) % slides.length;
          if (slides[next]) gallery.setActiveMedia(slides[next].dataset.mediaId, false);
        }, { signal });
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-offer-input]')) return;
          this.selectInput(event.target);
        }, { signal });
        this.addEventListener('submit', (event) => {
          if (!event.target.matches('[data-dtc-form]')) return;
          event.preventDefault();
          this.addToCart(event.target, event.submitter);
        }, { signal });
        window.addEventListener('popstate', () => {
          const variantId = new URL(location.href).searchParams.get('variant');
          const offer = offers.find((item) => variantId && item.variantId === variantId);
          const count = new URL(location.href).searchParams.get('count');
          const counted = /^[1-3]$/.test(count || '') ? offers[Number(count) - 1] : null;
          this.controller.select((offer || counted || offers.find((item) => item.checked) || offers[0])?.key);
          this.updateMedia();
        }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (this.contains(event.target)) this.controller.select(event.detail.blockId);
        }, { signal });
        this.render();
        document.dispatchEvent(new CustomEvent('dtc:product-ready', { detail: { owner: this } }));
        if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', () => this.render(), { once: true, signal });
        customElements.whenDefined('media-gallery').then(() => {
          if (this.isConnected) this.updateMedia();
        });
      }

      disconnectedCallback() {
        document.dispatchEvent(new CustomEvent('dtc:product-disconnected', { detail: { owner: this } }));
        this.abort?.abort();
        this.request?.abort();
        this.request = null;
      }

      attachPlacement(root) {
        this.placements ||= new Set();
        this.placements.add(root);
        this.render();
      }
      detachPlacement(root) { this.placements?.delete(root); }
      offerNodes(selector) {
        return [...new Set([...this.querySelectorAll(selector), ...[...(this.placements || [])].flatMap(root => [...root.querySelectorAll(selector)])])];
      }
      selectInput(input) {
        this.clearErrors();
        this.controller.select(input.value);
        const offer = this.controller.selected;
        const url = new URL(location.href);
        url.searchParams.set('count', String(this.controller.offers.indexOf(offer) + 1));
        if (offer?.variantId) url.searchParams.set('variant', offer.variantId);
        else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
        this.updateMedia();
      }

      render() {
        const { selected, busy } = this.controller;
        const enabled = Boolean(selected?.available && selected.purchasable && selected.variantId);
        this.offerNodes('[data-offer-input]').forEach((input) => {
          input.checked = input.value === selected?.key;
          input.disabled = busy;
        });
        this.offerNodes('[data-dtc-form]').forEach((form) => {
          const id = form.querySelector('[name="id"]');
          id.value = selected?.variantId || '';
          id.disabled = !enabled;
          const button = form.querySelector('[type="submit"]');
          button.disabled = busy || !enabled;
          button.classList.toggle('loading', busy);
          form.setAttribute('aria-busy', String(busy));
          button.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
          form.querySelector('[data-purchase-label]').textContent = !selected?.purchasable ? this.dataset.unavailableLabel : this.dataset.addLabel;
        });
        this.offerNodes('[data-selected-price]').forEach((node) => { node.textContent = selected?.price || ''; });
        this.offerNodes('[data-selected-compare]').forEach((node) => { node.textContent = selected?.compare || ''; node.hidden = !selected?.compare; });
        this.offerNodes('[data-selected-discount]').forEach((node) => { node.textContent = selected?.discount || ''; node.hidden = !selected?.discount; });
        this.offerNodes('[data-selected-availability]').forEach((node) => { node.textContent = selected?.availability || this.dataset.unavailableLabel; });
        this.offerNodes('[data-selected-savings]').forEach((node) => { node.textContent = selected?.savings || ''; node.hidden = !selected?.savings; });
        this.offerNodes('[data-kit-gifts]').forEach((node) => { node.hidden = node.dataset.kitGifts !== selected?.key; node.classList.toggle('is-unlocked', !node.hidden); });
        this.offerNodes('[data-gift-tier]').forEach((node) => { const locked = Number(node.dataset.giftTier) > Number(selected?.tier || 1); node.classList.toggle('is-locked', locked); });
        this.offerNodes('[data-offer-summary]').forEach((node) => { node.textContent = selected?.price || ''; });
      }

      updateMedia() {
        const mediaId = this.controller.selected?.mediaId;
        const gallery = this.querySelector('media-gallery');
        const empty = gallery?.querySelector?.('[data-variant-media-empty]');
        if (empty) empty.hidden = Boolean(mediaId);
        gallery?.classList?.toggle('dtc-variant-no-media', !mediaId);
        if (mediaId) {
          gallery?.setActiveMedia?.(`${this.dataset.sectionId}-${mediaId}`, false);
          const activeImage = gallery?.querySelector?.(`[data-media-id="${this.dataset.sectionId}-${mediaId}"] img`);
          if (activeImage) { activeImage.loading = 'eager'; activeImage.fetchPriority = 'high'; }
        }
      }

      clearErrors() {
        this.offerNodes('[data-purchase-error]').forEach((node) => { node.hidden = true; node.textContent = ''; });
      }

      async addToCart(form, submitter) {
        const offer = this.controller.selected;
        if (this.controller.busy || !offer?.available || !offer.purchasable || !offer.variantId) return;
        const controller = this.controller;
        controller.setBusy(true);
        this.clearErrors();
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = document.querySelector('[data-dtc-cart-config]');
        this.request = new AbortController();
        const service = new window.DtcOfferCart({ signal: this.request.signal, root: this.dataset.rootUrl || '/', addUrl: window.routes?.cart_add_url, messages: config?.dataset || {} });
        if (cart) cart.setActiveElement(submitter || form.querySelector('[type="submit"]'));
        try {
          const result = await service.add(offer, { sections: cart?.getSectionsToRender().map((section) => section.id), path: location.pathname });
          if (!this.isConnected || this.controller !== controller) return;
          cart?.classList.toggle('is-empty', result.cart.items.length === 0);
          document.dispatchEvent(new CustomEvent('dtc:cart', { detail: result.cart }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dtc-offers', productVariantId: offer.variantId, cartData: result.state }).catch(() => {});
          this.querySelector('[data-cart-status]').textContent = this.dataset.addedLabel;
          if (cart && cart.getSectionsToRender().every((section) => result.state.sections?.[section.id])) cart.renderContents(result.state);
          else location.assign(window.routes?.cart_url || service.root + 'cart');
        } catch (error) {
          if (!this.isConnected || this.controller !== controller) return;
          this.offerNodes('[data-purchase-error]').forEach((node) => { node.textContent = error.message || this.dataset.errorLabel; node.hidden = false; });
          if (cart) {
            try {
              const sections = await service.sections(cart.getSectionsToRender().map((section) => section.id), location.pathname);
              if (cart.classList.contains('active')) cart.renderContents({ sections });
              else {
                const counter = document.querySelector('#cart-icon-bubble');
                if (counter && sections['cart-icon-bubble']) counter.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble'];
              }
            } catch {}
          }
        } finally { if (this.controller === controller) controller.setBusy(false); }
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-offer-repeat"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dtc-offer-repeat')) customElements.define('dtc-offer-repeat', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController(); const { signal } = this.abort;
    document.addEventListener('dtc:product-ready', e => this.mount(e.detail.owner), { signal });
    document.addEventListener('dtc:product-disconnected', e => { if (e.detail.owner === this.owner) this.unmount(); }, { signal });
    this.addEventListener('change', e => { if (e.target.matches('[data-offer-input]')) this.owner?.selectInput(e.target); }, { signal });
    this.addEventListener('submit', e => { if (!e.target.matches('[data-dtc-form]')) return; e.preventDefault(); this.owner?.addToCart(e.target, e.submitter); }, { signal });
    const owner = document.querySelector('dtc-product'); if (owner?.controller) this.mount(owner);
  }
  mount(owner) {
    const template = owner.querySelector('[data-dtc-repeat-template]'); if (!template) return;
    this.unmount(); this.owner = owner; this.replaceChildren(template.content.cloneNode(true));
    const styles = getComputedStyle(owner); for (const key of styles) if (key.startsWith('--dtc-')) this.style.setProperty(key, styles.getPropertyValue(key));
    owner.attachPlacement(this);
  }
  unmount() { this.owner?.detachPlacement(this); this.owner = null; this.replaceChildren(); }
  disconnectedCallback() { this.abort?.abort(); this.unmount(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-product-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dtc-info-source')) customElements.define('dtc-info-source', class extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort = new AbortController(); const { signal } = this.abort;
  this.content ||= this.querySelector('dtc-info-content');
  const mount = () => { const target = document.querySelector('dtc-product .dtc-product__faq'); if (target && this.content) target.prepend(this.content); };
  document.addEventListener('dtc:product-ready', mount, { signal });
  document.addEventListener('dtc:product-disconnected', () => { if (this.content) this.append(this.content); }, { signal });
  document.addEventListener('shopify:block:select', e => { if (this.content?.contains(e.target)) { const detail = e.target.closest('details'); if (detail) detail.open = true; } }, { signal }); mount();
 }
 disconnectedCallback() { this.abort?.abort(); this.content?.remove(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-video-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dtc-review-video')) customElements.define('dtc-review-video', class extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort = new AbortController(); const { signal } = this.abort;
  const video = this.querySelector('video'), button = this.querySelector('[data-play]'); if (!video || !button) return;
  const loading = this.querySelector('[data-video-loading]'), error = this.querySelector('[data-video-error]');
  const busy = value => { this.setAttribute('aria-busy', String(value)); loading.hidden = !value; };
  const fail = () => { busy(false); error.hidden = false; button.hidden = false; this.classList.remove('is-playing'); };
  button.addEventListener('click', () => { error.hidden = true; busy(true); try { video.play()?.catch(fail); } catch { fail(); } }, { signal });
  video.addEventListener('waiting', () => busy(true), { signal });
  video.addEventListener('playing', () => { busy(false); button.hidden = true; this.classList.add('is-playing'); document.querySelectorAll('dtc-review-video video').forEach(other => { if (other !== video) other.pause(); }); }, { signal });
  for (const type of ['pause','ended']) video.addEventListener(type, () => { busy(false); button.hidden = false; this.classList.remove('is-playing'); }, { signal });
  video.addEventListener('error', fail, { signal });
 }
 disconnectedCallback() { this.abort?.abort(); this.querySelector('video')?.pause(); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
